import "dayjs/locale/en"
import "dayjs/locale/cs"

export enum Language {
    CS = "CS",
    EN = "EN"
}

interface DayjsLocale {
    code: string;
}

const languageToLocaleMap = new Map<string, DayjsLocale>([
    [Language.CS, {code: "cs"}],
    [Language.EN, {code: "en"}]
]);

export function languageToLocale(language: Language): string | undefined {
    return languageToLocaleMap.get(language)?.code;
}

export function languageFromCode(code: string | undefined): Language | undefined {
    if (code) {
        const langCode = Object.entries(Language)
            .map(([langCode]) => langCode)
            .find((langCode) => langCode === code);
        if (langCode) {
            return langCode as Language;
        }
    }
    return undefined;
}